import { render, staticRenderFns } from "./ItemRepertorio.vue?vue&type=template&id=20075082&scoped=true&"
import script from "./ItemRepertorio.vue?vue&type=script&lang=js&"
export * from "./ItemRepertorio.vue?vue&type=script&lang=js&"
import style0 from "./ItemRepertorio.vue?vue&type=style&index=0&id=20075082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20075082",
  null
  
)

export default component.exports